export default __webpack_public_path__ + "static/media/sisgem.d3c2b571.png";